import React, { useEffect, useRef, useState } from 'react';
import { tokens } from '@domain-group/fe-brary';
import * as styles from './card-banner.style';

const { colors } = tokens;

const WHITE_COLOURS = ['#fff', '#ffffff', 'white'];

export interface CardBannerProps {
  agencyName: string;
  logoUrl?: string;
  logoColour?: string;
  priority?: boolean;
}

const CardBanner = ({
  agencyName,
  logoUrl,
  logoColour,
  priority = false,
}: CardBannerProps): JSX.Element => {
  const imageRef = useRef<HTMLImageElement>(null);
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  useEffect(() => {
    const image = imageRef.current;

    if (image && image.complete && image.naturalWidth === 0) {
      setFailedSrc(logoUrl ?? null);
    }
  }, [logoUrl]);

  const isWhiteBanner =
    !logoColour || WHITE_COLOURS.includes(logoColour.trim().toLowerCase());

  return (
    <div
      css={styles.banner(
        logoColour || colors.neutral.surface.default,
        isWhiteBanner,
      )}
    >
      {logoUrl && logoUrl !== failedSrc && (
        <img
          ref={imageRef}
          css={styles.logo}
          src={logoUrl}
          alt={agencyName}
          loading={priority ? 'eager' : 'lazy'}
          fetchPriority={priority ? 'high' : undefined}
          onError={() => setFailedSrc(logoUrl)}
        />
      )}
    </div>
  );
};

export default CardBanner;
